module.exports = __webpack_public_path__ + "img/illustration_mobile_fran.a6bd89e8.png";